import { AnalyticsState, AutomationFilter } from 'apps/performanceAnalytics/store/types'
import {
  CombinedStatistics,
  ContentAnalyticsSortField,
  SortOrder,
} from 'shared/api/requests/analytics/schemas'

const hasAutomation = (item: CombinedStatistics) => item.automation

const getSortValue = (item: CombinedStatistics, field: ContentAnalyticsSortField) => {
  switch (field) {
    case ContentAnalyticsSortField.REACH:
      return item.content.reach
    case ContentAnalyticsSortField.ENGAGEMENT_RATE:
      return item.content.engagement_rate
    case ContentAnalyticsSortField.CONTACTS_CAPTURED:
      return item.automation?.contacts_captured
    case ContentAnalyticsSortField.AUTOMATION_REACH:
      return item.automation?.reach
    case ContentAnalyticsSortField.AUTOMATION_CTR:
      return item.automation?.ctr
  }
}

export const filterAndSortContentStatistics = (
  list: CombinedStatistics[],
  { contentType, automation, sortField, sortOrder }: AnalyticsState['query'],
) => {
  const filtered = list.filter((item) => {
    if (contentType !== null && item.content.post_type !== contentType) {
      return false
    }

    if (automation === AutomationFilter.WITH && !hasAutomation(item)) {
      return false
    }

    if (automation === AutomationFilter.WITHOUT && hasAutomation(item)) {
      return false
    }

    return true
  })

  if (sortField === null || sortOrder === null) {
    return filtered
  }

  const direction = sortOrder === SortOrder.DESC ? -1 : 1

  return filtered.sort((contentA, contentB) => {
    const sortValueA = getSortValue(contentA, sortField) ?? -1
    const sortValueB = getSortValue(contentB, sortField) ?? -1

    return (sortValueA - sortValueB) * direction
  })
}
